// extracted by mini-css-extract-plugin
export var newIcon = "style-module--new-icon--79b5b";